import React, { useMemo, useState } from 'react';
import { useConfigProvider } from '@/lib/context';
import { CatalogCompany } from '@/shared/types/catalog';
import NotablePastProjects from '../NotablePastProjects';
import { Tooltip } from 'antd';
import Image from 'next/image';
import './index.less';
import { size } from 'lodash-es';
import { CountryFlagEmoji } from '@/shared/constants/country-flag';
import SupplierStats from '../SupplierStats';

interface IProps {
  supplier: CatalogCompany;
  onReviewLabelClick?: () => void;
  isMobileFromServer?: boolean;
}

const SidebarLeft = ({ supplier, isMobileFromServer, onReviewLabelClick }: IProps) => {
  const { isMobile: isMobileFromClient } = useConfigProvider();
  const [showFullBio, setShowFullBio] = useState<boolean>(false);
  const supplierName = useMemo(() => supplier?.name ?? '', [supplier]);
  const isMobile = isMobileFromServer ?? isMobileFromClient;

  const renderBio = (bio: string) => {
    const maxChars = isMobile ? 100 : 320;
    const bioShowText = showFullBio ? bio : bio.substring(0, maxChars);

    const ifShowSeeMore = !showFullBio && size(bio) > maxChars;
    const isShowSeeLess = showFullBio && size(bio) > maxChars;

    return (
      <div
        className="supplier-bio"
        onClick={() => {
          setShowFullBio(!showFullBio);
        }}
      >
        {bioShowText}
        {ifShowSeeMore && '...'}
        {ifShowSeeMore && <span className="toggle-bio">See more</span>}
        {isShowSeeLess && <span className="toggle-bio">See less</span>}
      </div>
    );
  };

  const renderCountry = (supplier: CatalogCompany) => {
    if (supplier?.countryCode && supplier?.country) {
      return (
        <div className="supplier-country-box">
          <p className="bold-text">Based in</p>
          <p className="country-text">{supplier.country}</p>
          <Tooltip placement="bottom" title={supplier.country}>
            {CountryFlagEmoji[supplier.countryCode]}
          </Tooltip>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="profile-sidebar-left">
      <div className="section supplier-info-section">
        <div className="supplier-info">
          {supplier?.avatarUrl && (
            <>
              <Image
                className="avatar"
                src={supplier.avatarUrl}
                width={48}
                height={48}
                sizes="(min-width:801px) 32px,48px"
                alt={supplierName}
                loading="lazy"
              />
            </>
          )}
          {supplier?.name && <h1 className="supplier-name">{supplier?.name}</h1>}
        </div>
        {renderBio(supplier?.bio ?? '')}
        {renderCountry(supplier)}
      </div>

      <div className="section notable-section">
        <NotablePastProjects supplier={supplier} />
      </div>

      <div className="section stats-section">
        {!isMobile && <SupplierStats supplier={supplier} onReviewLabelClick={onReviewLabelClick} />}
      </div>
    </div>
  );
};

export default SidebarLeft;
